import React, { SetStateAction } from "react";
import Modal from "../hooks/Modal";
import { NavigateFunction } from "react-router-dom";
import Button from "./button/button";
import VerifyButton from "../pages/profile/components/verifyButton";
import { useUserData } from "../hooks/userUserData";
import { UserProfileData } from "../pages/profile/types/profileTypes";

const AuthModal = ({
  setIsOpen,
  isOpen,
  modalType,
  navigate,
}: {
  setIsOpen: React.Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  modalType:
    | "verify"
    | "subscExpired"
    | "upgradeRequired"
    | "service"
    | "jobRequest"
    | null;
  navigate?: NavigateFunction;
}) => {
  const { user } = useUserData();
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Auth Modal"}
      className="w-[90%] sm:w-[80%] md:w-2/3 lg:w-1/2 max-w-lg"
    >
      <div className="w-full text-center px-2 sm:px-4 md:px-6">
        {modalType === "verify" && (
          <>
            <h2 className="text-xl sm:text-2xl md:text-3xl text-center font-semibold">
              Verify Your Email
            </h2>
            <div className="my-4 sm:my-5 md:my-7 text-sm sm:text-base md:text-lg">
              You need to verify your mail to access this page
            </div>
          </>
        )}
        {modalType === "subscExpired" && (
          <>
            <h2 className="text-xl sm:text-2xl md:text-3xl text-center font-semibold">
              Renew Your Subscription
            </h2>
            <div className="my-4 sm:my-5 md:my-7 text-sm sm:text-base md:text-lg">
              You need to renew your subscription to access this page
            </div>
          </>
        )}
        {modalType === "upgradeRequired" && (
          <>
            <h2 className="text-xl sm:text-2xl md:text-3xl text-center font-semibold">
              Upgrade to professional plan
            </h2>
            <div className="my-4 sm:my-5 md:my-7 text-sm sm:text-base md:text-lg">
              Please upgrade your plan to contact the client
            </div>
          </>
        )}
        {modalType === "service" && (
          <>
            <h2 className="text-xl sm:text-2xl md:text-3xl text-center font-semibold">
              Upgrade to professional plan
            </h2>
            <div className="my-4 sm:my-5 md:my-7 text-sm sm:text-base md:text-lg">
              Please upgrade your plan to preview the job requests related to
              the service
            </div>
          </>
        )}
        <div className="flex flex-col-reverse sm:flex-row justify-center items-center gap-4 sm:gap-6 md:gap-8 lg:gap-12">
          {modalType === "verify" && (
            <VerifyButton
              user={user as UserProfileData}
              className="w-full sm:w-40"
            />
          )}
          {modalType === "upgradeRequired" && (
            <button
              onClick={() => {
                navigate && navigate("/userSubscription");
                setIsOpen(false);
              }}
              className="transition-all text-#634C36 bg-primary rounded-lg inline-block p-2 sm:p-3 my-4 sm:my-5 md:my-7 font-medium hover:translate-y-1 w-full sm:w-40"
            >
              Upgrade now
            </button>
          )}
          <Button
            variant="cancel"
            size="medium"
            onClick={() => setIsOpen(false)}
            className="w-full sm:w-40"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AuthModal;
